module.exports = __webpack_public_path__ + "img/iroasu_main.15a7cbb6.png";